import useDashboardAccess from "@/hooks/useDashboardAccess";

export default function useSmsCreditAccess() {
  const { isManager, isLoading } = useDashboardAccess();
  return { allowed: isManager, isLoading };
}
